import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, withModifiers as _withModifiers, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = { class: "table-top-controls" }
const _hoisted_3 = {
  key: 0,
  class: "sort-conditions-display"
}
const _hoisted_4 = { class: "sort-conditions-container" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "sort-conditions-display"
}
const _hoisted_8 = { class: "top-buttons" }
const _hoisted_9 = { class: "invalid-data-info" }
const _hoisted_10 = ["max", "disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  ref: "tableRef",
  class: "csv-table"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "conflict-badge"
}
const _hoisted_16 = ["title"]
const _hoisted_17 = ["data-id"]
const _hoisted_18 = ["data-row", "data-col"]
const _hoisted_19 = { class: "table-controls" }
const _hoisted_20 = { class: "column-selector" }
const _hoisted_21 = { class: "selected-columns-display" }
const _hoisted_22 = { class: "column-name" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "sort-title"
}
const _hoisted_25 = { class: "pagination-controls" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "page-info" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "page-separator"
}
const _hoisted_31 = ["max"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "sort-settings"
}
const _hoisted_34 = { class: "sort-header" }
const _hoisted_35 = { class: "sort-options" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefineModel = _resolveComponent("RefineModel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "sort-settings-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSortSettings && _ctx.toggleSortSettings(...args)))
        }, _cache[21] || (_cache[21] = [
          _createElementVNode("img", {
            src: "/table_icon/conditions.svg",
            alt: "Multi-level Sort Settings",
            class: "sort-icon"
          }, null, -1)
        ])),
        (
            _ctx.sortConditions &&
            _ctx.sortConditions.length > 0 &&
            _ctx.sortConditions[0].columnName
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "sort-title" }, "Condition", -1)),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortConditions, (condition, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "sort-condition-item",
                    key: index
                  }, [
                    _createElementVNode("img", {
                      src: `/table_icon/sort_${index + 1}.svg`,
                      alt: `Condition ${index + 1}`,
                      class: "condition-number-icon"
                    }, null, 8, _hoisted_5),
                    _createTextVNode(" " + _toDisplayString(condition.columnName) + " ", 1),
                    _createElementVNode("img", {
                      src: `/table_icon/${
                  condition.order === 'asc' ? 'asc' : 'desc'
                }.svg`,
                      alt: condition.order === 'asc' ? 'asc' : 'desc',
                      class: "sort-direction-icon"
                    }, null, 8, _hoisted_6)
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[23] || (_cache[23] = [
              _createElementVNode("span", { class: "sort-title" }, "Conditions: None", -1)
            ]))),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.invalidInputIndex) = $event)),
              min: 1,
              max: _ctx.jumpHighlightIndex.length,
              class: "inline-invalid-input",
              disabled: !_ctx.hasHighlightedData,
              onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.jumpToSpecificInvalid && _ctx.jumpToSpecificInvalid(...args)), ["enter"]))
            }, null, 40, _hoisted_10), [
              [
                _vModelText,
                _ctx.invalidInputIndex,
                void 0,
                { number: true }
              ]
            ]),
            _createTextVNode(" / " + _toDisplayString(_ctx.jumpHighlightIndex.length) + " Invalid Data ", 1)
          ]),
          _createElementVNode("button", {
            class: "invalid-data-button-last",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.jumpToPrevInvalidData && _ctx.jumpToPrevInvalidData(...args))),
            disabled: !_ctx.hasHighlightedData
          }, _cache[24] || (_cache[24] = [
            _createElementVNode("img", {
              src: "/table_icon/lastpage.svg",
              alt: "Previous",
              class: "button-icon"
            }, null, -1),
            _createElementVNode("span", { class: "button-text-last" }, "Last", -1)
          ]), 8, _hoisted_11),
          _createElementVNode("div", {
            class: _normalizeClass(["button-divider", { 'disabled-divider': !_ctx.hasHighlightedData }])
          }, null, 2),
          _createElementVNode("button", {
            class: "invalid-data-button-next",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.jumpToNextInvalidData && _ctx.jumpToNextInvalidData(...args))),
            disabled: !_ctx.hasHighlightedData
          }, _cache[25] || (_cache[25] = [
            _createElementVNode("span", { class: "button-text-next" }, "Next", -1),
            _createElementVNode("img", {
              src: "/table_icon/nextpage.svg",
              alt: "Next",
              class: "button-icon"
            }, null, -1)
          ]), 8, _hoisted_12)
        ])
      ]),
      _createElementVNode("div", {
        class: "scrollable-container",
        ref: "scrollableContainerRef",
        onMousedown: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDown && _ctx.handleMouseDown(...args))),
        onMousemove: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleMouseMove && _ctx.handleMouseMove(...args))),
        onMouseup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleMouseUp && _ctx.handleMouseUp(...args))),
        onMouseleave: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args))),
        onScroll: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateSelectionIconPosition && _ctx.updateSelectionIconPosition(...args)))
      }, [
        (_ctx.isDragging)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "selection-box",
              style: _normalizeStyle({
            left: _ctx.selectionBox.left + 'px',
            top: _ctx.selectionBox.top + 'px',
            width: _ctx.selectionBox.width + 'px',
            height: _ctx.selectionBox.height + 'px',
          })
            }, null, 4))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_13, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, cellIndex) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: header,
                  draggable: "true",
                  class: _normalizeClass({
                  'selected-column': _ctx.selectedColumns.includes(header),
                  'disabled-column': !_ctx.isColumnEnabled(header),
                }),
                  style: _normalizeStyle(_ctx.columnWidthStyle),
                  onClick: ($event: any) => (_ctx.toggleColumnSelection(header))
                }, [
                  (_ctx.columnConflictCounts[header] > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.columnConflictCounts[header]), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: "header-text",
                    title: header
                  }, _toDisplayString(header), 9, _hoisted_16),
                  _createElementVNode("div", {
                    ref_for: true,
                    ref: 'histogram-' + cellIndex,
                    class: "histogram-container"
                  }, null, 512)
                ], 14, _hoisted_14))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedRows, (row, rowIndex) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: rowIndex,
                "data-id": row.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(row), (cell, cellIndex) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: cellIndex,
                    class: _normalizeClass([
                  _ctx.highlightCell(row.id as number, cellIndex),
                  _ctx.isSelectedCell(rowIndex, cellIndex) ? 'selected-cell' : ''
                ]),
                    "data-row": rowIndex,
                    "data-col": cellIndex,
                    style: _normalizeStyle(_ctx.columnWidthStyle)
                  }, _toDisplayString(cell), 15, _hoisted_18))
                }), 128))
              ], 8, _hoisted_17))
            }), 128))
          ])
        ], 512),
        (_ctx.selectedCells.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "selection-icon",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showSelectionMenu && _ctx.showSelectionMenu(...args)))
            }))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (_ctx.showSelectionOptions)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "selection-menu",
                style: _normalizeStyle(_ctx.selectionMenuStyle)
              }, [
                _createElementVNode("div", {
                  class: "menu-option",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleOptionValid && _ctx.handleOptionValid(...args)))
                }, _cache[26] || (_cache[26] = [
                  _createElementVNode("img", {
                    src: "/valid_example.png",
                    alt: "Icon 1",
                    class: "menu-icon"
                  }, null, -1),
                  _createTextVNode(" Valid Example ")
                ])),
                _createElementVNode("div", {
                  class: "menu-option dashed",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleOptionInvalid && _ctx.handleOptionInvalid(...args)))
                }, _cache[27] || (_cache[27] = [
                  _createElementVNode("img", {
                    src: "/invalid_example.png",
                    alt: "Icon 2",
                    class: "menu-icon"
                  }, null, -1),
                  _createTextVNode(" Invalid Example ")
                ]))
              ], 4))
            : _createCommentVNode("", true)
        ]))
      ], 544),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "sort-title" }, "Selected Columns", -1)),
            (_ctx.selectedColumns && _ctx.selectedColumns.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedColumns, (column) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "column-tag",
                    key: column
                  }, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(column), 1),
                    _createElementVNode("span", {
                      class: "delete-icon",
                      onClick: _withModifiers(($event: any) => (_ctx.removeColumn(column)), ["stop"])
                    }, "×", 8, _hoisted_23)
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("span", _hoisted_24, ":None"))
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          (_ctx.isFiltered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("span", null, "filtered: " + _toDisplayString(_ctx.currentFilterInfo?.column) + " = " + _toDisplayString(_ctx.currentFilterInfo?.value), 1),
                _createElementVNode("button", {
                  class: "reset-filter-btn",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
                }, " reset filter ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
            disabled: _ctx.currentPage === 0
          }, _cache[29] || (_cache[29] = [
            _createElementVNode("img", {
              src: "/table_icon/lastpage_black.svg",
              alt: "Previous",
              class: "button-icon"
            }, null, -1)
          ]), 8, _hoisted_27),
          _createElementVNode("span", _hoisted_28, [
            (_ctx.totalPages > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.displayedPageNumbers, (pageNum, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["page-number", { 'current-page': pageNum === _ctx.currentPage + 1 }]),
                      onClick: ($event: any) => (_ctx.goToPageNumber(pageNum))
                    }, _toDisplayString(pageNum), 11, _hoisted_29),
                    (index < _ctx.displayedPageNumbers.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, ","))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" 0 total page ")
                ], 64))
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.inputPage) = $event)),
            min: "1",
            max: _ctx.totalPages,
            onKeyup: _cache[16] || (_cache[16] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goToPage && _ctx.goToPage(...args)), ["enter"])),
            placeholder: "input page number"
          }, null, 40, _hoisted_31), [
            [
              _vModelText,
              _ctx.inputPage,
              void 0,
              { number: true }
            ]
          ]),
          _createElementVNode("button", {
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
            disabled: _ctx.currentPage >= _ctx.totalPages - 1
          }, _cache[30] || (_cache[30] = [
            _createElementVNode("img", {
              src: "/table_icon/nextpage_black.svg",
              alt: "Next",
              class: "button-icon"
            }, null, -1)
          ]), 8, _hoisted_32)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showSortSettings)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _cache[31] || (_cache[31] = _createElementVNode("span", null, "Multi-level Sort Settings", -1)),
                _createElementVNode("button", {
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toggleSortSettings && _ctx.toggleSortSettings(...args)))
                }, "Close")
              ]),
              _createElementVNode("div", _hoisted_35, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortConditions, (sortCondition, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "sort-condition"
                  }, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((sortCondition.columnName) = $event)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: header,
                          value: header
                        }, _toDisplayString(header), 9, _hoisted_37))
                      }), 128))
                    ], 8, _hoisted_36), [
                      [_vModelSelect, sortCondition.columnName]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((sortCondition.order) = $event)
                    }, _cache[32] || (_cache[32] = [
                      _createElementVNode("option", { value: "asc" }, "Ascending", -1),
                      _createElementVNode("option", { value: "desc" }, "Descending", -1)
                    ]), 8, _hoisted_38), [
                      [_vModelSelect, sortCondition.order]
                    ]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.removeSortCondition(index))
                    }, "Delete", 8, _hoisted_39)
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addSortCondition && _ctx.addSortCondition(...args)))
                }, "Add Condition")
              ]),
              _createElementVNode("button", {
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.applySortSettings && _ctx.applySortSettings(...args)))
              }, "Apply Sort")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showRefineModal)
      ? (_openBlock(), _createBlock(_component_RefineModel, {
          key: 0,
          isInvalid: !_ctx.validFlag,
          selectedData: _ctx.selectedCellsData,
          refineResult: _ctx.refineResult,
          onClose: _ctx.closeRefineModal,
          onSubmit: _ctx.handleRefineSubmit
        }, null, 8, ["isInvalid", "selectedData", "refineResult", "onClose", "onSubmit"]))
      : _createCommentVNode("", true)
  ]))
}